// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../shared/assets/icons/Vector.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../shared/assets/icons/mobileBar.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setup_imgSize__5oFLY {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
}

/* Target the specific section */
.setup_custom-scrollbar__90uN5::-webkit-scrollbar {
  width: 5px; /* Adjust scrollbar width */
}

.setup_custom-scrollbar__90uN5::-webkit-scrollbar-track {
  background: var(--disabled-color); /* Track background color */
}

.setup_custom-scrollbar__90uN5::-webkit-scrollbar-thumb {
  background-color: var(--primary-color); /* Thumb color */
  border-radius: 10px; /* Optional: Rounded corners */
}

.setup_custom-scrollbar__90uN5::-webkit-scrollbar-thumb:hover {
  background: var(--primary-color); /* Thumb hover effect */
}

@media only screen and (max-width: 600px) {
  .setup_imgSize__5oFLY {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .setup_clientformsetup__CCH4S {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/setup.module.css"],"names":[],"mappings":"AAAA;EACE,yDAA0D;EAC1D,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,UAAU,EAAE,2BAA2B;AACzC;;AAEA;EACE,iCAAiC,EAAE,2BAA2B;AAChE;;AAEA;EACE,sCAAsC,EAAE,gBAAgB;EACxD,mBAAmB,EAAE,8BAA8B;AACrD;;AAEA;EACE,gCAAgC,EAAE,uBAAuB;AAC3D;;AAEA;EACE;IACE,yDAA6D;IAC7D,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".imgSize {\n  background-image: url(\"../shared/assets/icons/Vector.jpg\");\n  background-size: cover;\n  background-position: center;\n}\n\n/* Target the specific section */\n.custom-scrollbar::-webkit-scrollbar {\n  width: 5px; /* Adjust scrollbar width */\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: var(--disabled-color); /* Track background color */\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background-color: var(--primary-color); /* Thumb color */\n  border-radius: 10px; /* Optional: Rounded corners */\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: var(--primary-color); /* Thumb hover effect */\n}\n\n@media only screen and (max-width: 600px) {\n  .imgSize {\n    background-image: url(\"../shared/assets/icons/mobileBar.jpg\");\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n  .clientformsetup {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imgSize": `setup_imgSize__5oFLY`,
	"custom-scrollbar": `setup_custom-scrollbar__90uN5`,
	"clientformsetup": `setup_clientformsetup__CCH4S`
};
export default ___CSS_LOADER_EXPORT___;
